import apiClient from './api';

export const usuarioService = {
  // Crear un nuevo usuario (registro) - usa endpoint de auth
  createUsuario: async (data) => {
    const payload = {
      name: data.nombre || data.name,
      lastname: data.apellido || data.lastname || '',
      email: data.email || data.correo,
      password: data.password,
      dni: data.dni || '',
      rol: data.rol || 'POSTULANTE',
      supervisorId: data.supervisorId || null
    };
    const response = await apiClient.post('/auth/register', payload);
    return response.data;
  },

  // Listar todos los usuarios (requiere autenticación ADMIN/SISTEMAS)
  getAllUsuarios: async () => {
    const response = await apiClient.get('/usuarios');
    return response.data;
  },

  // Actualizar un usuario existente
  updateUsuario: async (id, data) => {
    const response = await apiClient.put(`/usuarios/${id}`, data);
    return response.data;
  },

  // Eliminar un usuario
  deleteUsuario: async (id) => {
    const response = await apiClient.delete(`/usuarios/${id}`);
    return response.data;
  },

  // Reenviar credenciales al usuario por email
  resendCredentials: async (id) => {
    const response = await apiClient.post(`/usuarios/${id}/resend-credentials`);
    return response.data;
  },

  // Cambiar estado de aptitud del usuario
  cambiarApto: async (usuarioId, apto) => {
    const response = await apiClient.patch(`/usuarios/${usuarioId}/apto?apto=${apto}`);
    return response.data;
  },

  // Crear múltiples usuarios de forma masiva
  createUsuariosMasivo: async (usuarios) => {
    const resultados = {
      exitosos: [],
      fallidos: []
    };

    for (const usuario of usuarios) {
      try {
        const usuarioCreado = await usuarioService.createUsuario(usuario);
        console.log('🔍 Usuario creado (respuesta del backend):', usuarioCreado);
        
        // El backend retorna {message, rol} pero NO el ID
        // Debemos buscar el usuario recién creado por su username (DNI)
        let usuarioConId = null;
        
        // Si la respuesta tiene ID directamente
        if (usuarioCreado?.id) {
          usuarioConId = usuarioCreado;
        } else if (usuarioCreado?.user?.id) {
          usuarioConId = usuarioCreado.user;
        } else if (usuarioCreado?.usuario?.id) {
          usuarioConId = usuarioCreado.usuario;
        } else if (usuarioCreado?.data?.id) {
          usuarioConId = usuarioCreado.data;
          } else {
            // Si no hay ID en la respuesta, buscamos el usuario por DNI
            console.log(`🔍 Backend no retornó ID. Buscando usuario por DNI: ${usuario.dni}`);
            
            // Esperar 500ms para que el backend termine de guardar
            await new Promise(resolve => setTimeout(resolve, 500));
            
            try {
              // Obtener todos los usuarios y buscar por dni
              const todosLosUsuarios = await usuarioService.getAllUsuarios();
              console.log(`🔍 Total usuarios en sistema: ${todosLosUsuarios.length}`);
              console.log(`🔍 Buscando usuario con DNI: "${usuario.dni}"`);
              
              // Buscar por dni
              usuarioConId = todosLosUsuarios.find(u => 
                u.dni === usuario.dni
              );
              
              if (usuarioConId) {
                console.log(`✅ Usuario encontrado: ID ${usuarioConId.id}, DNI: ${usuarioConId.dni}, email: ${usuarioConId.email}`);
              } else {
                console.error(`❌ No se pudo encontrar el usuario con DNI: ${usuario.dni}`);
                console.error('🔍 Usuarios disponibles:', todosLosUsuarios.map(u => ({ id: u.id, dni: u.dni, email: u.email })));
              }
            } catch (busquedaError) {
              console.error('❌ Error al buscar usuario:', busquedaError);
            }
          }        console.log('🔍 Usuario final con ID:', usuarioConId);
        console.log('🔍 ID del usuario:', usuarioConId?.id);
        
        resultados.exitosos.push({
          usuario: usuarioConId,
          datos: usuario
        });
      } catch (error) {
        console.error('❌ Error al crear usuario:', error);
        resultados.fallidos.push({
          datos: usuario,
          error: error.response?.data?.message || error.message
        });
      }
    }

    return resultados;
  },
};

export default usuarioService;
